(function($, undefined) {

	'use strict';
	var doc = $(document);
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
    var formFileBtn;
	var provinceSelects;

	var validateForm = function (ctn) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input.required', t);
			var toValidateUpload = $('.file-upload.required', t);
			var toValidateCheck = $('.form-check-input:not(.radio).required', t);
			var toValidateRadio = $('.form-check-input.radio.required', t);
			var toValidateFriendlyUrl = $('.js-validate-friendlyUrl', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var checkOk = true;
			var termsOk = true;
			var friendlyUrlOk = true;
			var emailOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var tUpload = $(this);
				var input = $('.file-upload-input', tUpload);

				if (input.val() === '' || input[0].files === undefined) {
					tUpload.removeClass('success').addClass('error');
				} 

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');
					
					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}
				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			toValidateRadio.each(function () {
				var tRadio = $(this);
				var name = tRadio.attr('name');
				var tCtn = tRadio.closest('.form-checkbox-ctn');
				var tOuterCtn = tCtn.parent();
				
				if (!tRadio.is(':checked') && !$('.form-check-input[name='+name+']', tOuterCtn).is(':checked')) {
					tCtn.addClass('error');
					isOk = false;
				} else {
					tCtn.removeClass('error');
				}
			});

            if(toValidateFriendlyUrl.length !== 0){
                if(toValidateFriendlyUrl.hasClass("error-friendlyUrl")){
                    friendlyUrlOk = false;
                    toValidateFriendlyUrl.find("input").addClass("error");
                }
            }
			if (password.length !== 0 && passwordConfirm.length !== 0 && (password.val() !== passwordConfirm.val() || password.val().length === 0)) {
				if (password.val().length === 0) {
					password.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					password.addClass('success').removeClass('error');
					passwordOk = true;
				}
                
				if (password.val() !== passwordConfirm.val() || (password.val().length === 0)) {
					passwordConfirm.removeClass('success').addClass('error');
					passwordOk = false;
				} else {
					passwordConfirm.removeClass('error');
					passwordOk = true;

					if (password.val().length !== 0) {
						passwordConfirm.addClass('success');
					}
				}
			}
			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}
                
				if (email.val() !== emailConfirm.val() || (email.val().length === 0)) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}
			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}
			
			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (password.length !== 0 && passwordConfirm.length !== 0) {
				if (password.length !== 0 && passwordOk) {
					ctn.addClass('has-password');
					password.add(passwordConfirm).removeClass('error');
					fieldsErrorPassword.slideUp(300);
				} else {
					ctn.removeClass('has-password');
					password.add(passwordConfirm).addClass('error');
					fieldsErrorPassword.slideDown(300);
				}
			}
			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}
            
			if (!isOk || !passwordOk || !termsOk || !checkOk || !friendlyUrlOk || !emailOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
                $('html, body').animate({
                    scrollTop: $(".error:eq(0)").offset().top - 90
                }, 2000);
                
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function (elt) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.val() === null ? '' : elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
        var targetCtn = classTarget.parent();
        var form = classTarget.closest('form');
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.‌​-]+(:[0-9]+)?|(?:www‌​.|[-;:&=\+\$,\w]+@)[‌​A-Za-z0-9.-]+)((?:\/‌​[\+~%\/.\w-_]*)?\??(‌​?:[-\+=&;%@.\w_]*)#?‌​(?:[\w]*))?)/;
		var numletter = /^[A-Za-z0-9]+$/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var errorEmail = $('.js-form-error-message.email');
		var emailValid = true;
		var urlValid = true;
		var numletterValid = true;
		var telValid = true;
		var inputValid = true;

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);

			if (!emailValid && val !== '') {
				errorEmail.slideDown(300);
				form.addClass('error-email');
			}
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		}else if (tag === 'INPUT' && validate === 'numletter' && validate !== 'default') {
			numletterValid = numletter.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.hasClass('required') && elt.val() !== '') {
				classTarget.removeClass('error').addClass('success');
                targetCtn.removeClass("error");
			} else {
				classTarget.addClass('error').removeClass('success');
                targetCtn.addClass("error");
			}
		} else {
			classTarget.addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.removeClass('success').addClass('error');
                targetCtn.addClass("error");
                inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.removeClass('success').removeClass('error');
                targetCtn.removeClass("error");
			}
		}

		if (emailValid && urlValid && telValid && inputValid && numletterValid) {
			classTarget.removeClass('error').addClass('success');
			targetCtn.removeClass('error');
		} else if (val.length === 0 && !classTarget.hasClass('required')) {
			classTarget.removeClass('error').removeClass('success');
			targetCtn.removeClass('error');
		} else {
			classTarget.addClass('error').removeClass('success');
			targetCtn.removeClass('error');
		}

		if (targetCtn.closest('.fake-ctn').length !== 0) {
			if (classTarget.hasClass('error')) {
				targetCtn.addClass('error');
			} else {
				targetCtn.removeClass('error');
			}
			if (classTarget.hasClass('success')) {
				targetCtn.addClass('success');
			} else {
				targetCtn.removeClass('success');
			}
		}
	};

	var formItemsBlur = function (t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('form');

		var errorEmail = $('.js-form-error-message.email', form);

		validateField(elt);

		// verifie si aucune erreur du meme type avant d'enlever le message d'erreur
		if (form.hasClass('error-email')) {
			var emailErrors = [];
			$('.form-input', form).each(function() {
				var t = $(this);
				if (t.attr('type') === 'email' && t.hasClass('error') && t.val() !== '') {
					emailErrors.push('error');
				}
			});

			if (emailErrors.length === 0) {
				errorEmail.slideUp(300);
				form.removeClass('error-email');
			}
		} else {
			errorEmail.slideUp(300);
		}


		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function () {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);
			
			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function () {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');
		var input = $('.form-input-checkbox-input', ctn);

		if (input.hasClass('is-checked')) {
			input.removeClass('is-checked');
		} else {
			input.addClass('is-checked');
		}
	};

	var toggleCheckbox = function () {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};


	var fileInputChange = function (e) {
		var t = $(this);
		var label = t.closest('.file-ctn');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.file-upload-title', label);
		var imageCtn = label.next().find(".file-image-inner");
		var imageEdited = label.next().find(".file-image-edited");
		var ctn = label;
		var form = ctn.closest('.js-form');
        
		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
            label.addClass("focused");
//            previewImage(t,imageCtn, imageEdited);
			labelValue.val(t.val().split('\\')[t.val().split('\\').length - 1]);
            if(t.hasClass("banner-pic")){
                $(".default-images-ctn").find("input:checked").prop('checked', false);
                t.parent().find("input.form-input").addClass("required");
            }
		} else {
			ctn.addClass('error').removeClass('success');
            label.removeClass("focused");
			labelValue.val(labelDefault);
            if(t.hasClass("banner-pic")){
                $(".default-images-ctn").find("input:eq(0)").prop('checked', true);
                t.parent().find("input").removeClass("required");
            }
		}
		
		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formSwitchClick =function (){
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop( "checked" )){
			elem.removeAttr( "checked" );
		}else{
			elem.attr( "checked", "checked" );
		}
	};

    var openInputFile = function(){
        var ctn = $(this).parent();
        var f = ctn.find("input[type = file]");
        f.trigger("click");
    };
    
    var limitChars = function(ed) {
        var max = parseInt(ed.getElement().maxLength);
        var _mem = "";
        if (!isNaN(max) && max > 0) {
            var allow = [0, 8, 9, 20, 27, 35, 36, 37, 38, 39, 40, 44, 46, 110, 144];
            ed.on("keydown", function(ev) {
                _mem = this.getContent().substring(0,max);
                if (allow.indexOf(ev.keyCode) !== -1 || ev.ctrlKey || ev.metaKey || this.contentWindow.getSelection().toString() !== "") {
                    return true;
                }
                if (tinymce_getContentLength(this) + 1 > max) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    return false;
                }
            });
            ed.on("keyup change", function(ev) {
                var text = this.getContent();
                if (text.length > max) {
                    this.setContent(text.substring(0, max));
                    text = text.substring(0, max);
//                    this.setSelectionRange(this.value.length,this.value.length);
                }
                tinymce_updateCharCounter(this, text.length);
            });
        }
    };
    var charCounter = function(ed) {
        if (!isNaN($('#' + ed.id).attr("maxlength"))) {
            $('#' + ed.id).prev().find('.mce-statusbar .mce-flow-layout').append('<div class="mce-char-count" style="text-align:right"></div>');
            tinymce_updateCharCounter(ed, tinymce_getContentLength(ed));
        }
    };
    function tinymce_updateCharCounter(el, len) {
        $('#' + el.id).prev().find('.mce-char-count').text(len + '/' + el.getElement().maxLength);
    }
    function tinymce_getContentLength(ed) {
        return ed.getContent().length;
    }
    

	var init = function (page) {
		body = $('body');
		items = $('.form-input:not([type=file]).required');
		provinceSelects = $('.province-select,.other-province-select,.state-select');
		
		// Otherwise, other selects for provinces/states don't get blur events
		if(provinceSelects.hasClass('required')) {
			items = $.merge(items, provinceSelects);
		}

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
//		file = $('.file-upload');
		fileInput = $('.file-upload-input');
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
        formFileBtn = $(".file-ctn .file-btn");
        
		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
        formFileBtn.click(openInputFile);
        
		items.each(function () {
			if (!$(this).hasClass('no-blur')) {
				$(this).blur(formItemsBlur);
			}
		});

	};


	var form = Fw.component.export('form', {
		init: init,
		validateForm: validateForm,
        limitChars: limitChars,
        charCounter: charCounter,
        formItemsBlur:formItemsBlur 
	});

})(jQuery);
